const ProductDetailImage = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_ImageSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'imageSettings',
        },
        options: {
          productImageHeight: {
            data: {
              max: 450,
              min: 80,
              step: 1,
            },
            type: 'RangePx',
          },
          backgroundSize: {
            type: 'Radio',
            order: 2,
            data: {
              direction: 'row',
              radioOptions: ['cover', 'contain', 'stretch'],
            },
          },
        },
      },
      Menu_ImageTitleSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'imageTitleSettings',
        },
        options: {
          imageTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 3,
          },
          imageTextColor: {
            type: 'HexColor',
            order: 4,
          },
          imageTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 5,
          },
          imageTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
          shareIcon: {
            type: 'IconSelector',
            data: {
              defaultIcon:
                'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
            },
            order: 7,
          },
          shareIconColor: {
            type: 'HexColor',
            order: 8,
          },
        },
      },
      Menu_FavoriteSettings: {
        type: 'Menu',
        order: 250,
        renderOptions: {
          controlKey: 'favoriteSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isHeartIcon',
            },
            options: {
              heartIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 17,
              },
              heartIconBackgroundColor: {
                type: 'HexColor',
                order: 18,
              },
              heartIconColor: {
                type: 'HexColor',
                order: 19,
              },
              selectedHeartIconColor: {
                type: 'HexColor',
                order: 20,
              },
              heartIconWidth: {
                order: 21,
                data: {
                  max: 20,
                  min: 10,
                  step: 1,
                },
                type: 'RangePx',
              },
              heartIconBorderRadius: {
                order: 22,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_ShareIconSettings: {
        type: 'Menu',
        order: 251,
        renderOptions: {
          controlKey: 'shareIconSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isShareIcon',
            },
            options: {
              shareIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 17,
              },
              shareIconBackgroundColor: {
                type: 'HexColor',
                order: 18,
              },
              shareIconColor: {
                type: 'HexColor',
                order: 19,
              },
              shareIconWidth: {
                order: 21,
                data: {
                  max: 20,
                  min: 10,
                  step: 1,
                },
                type: 'RangePx',
              },
              shareIconBorderRadius: {
                order: 22,
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_BarcodeSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'barcodeSettings',
        },
        options: {
          showBarcode: {
            type: 'Radio',
            order: 8,
            data: {
              direction: 'row',
              radioOptions: ['none', 'flex'],
            },
          },
          barcodeTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 9,
          },
          barcodeTextColor: {
            type: 'HexColor',
            order: 10,
          },
          barcodeTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 11,
          },
          barcodeTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
        },
      },
      Menu_BrandSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'brandSettings',
        },
        options: {
          showBrandName: {
            type: 'Radio',
            order: 8,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          brandNameTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 9,
          },
          brandNameTextColor: {
            type: 'HexColor',
            order: 10,
          },
          brandNameTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 11,
          },
          brandNameTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 6,
          },
        },
      },
      Menu_StarSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'starSettings',
        },
        options: {
          isShowStar: {
            type: 'Radio',
            order: 11,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          starSize: {
            type: 'RangePx',
            data: {
              max: 36,
              min: 6,
              step: 1,
            },
            order: 12,
          },
        },
      },
      Menu_TagBoxSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'tagBoxSettings',
        },
        options: {
          isShowTag: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          tagIconColor: {
            type: 'HexColor',
            order: 2,
          },
          tagIconSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 3,
          },
          tagBackgroundColor: {
            type: 'HexColor',
            order: 4,
          },
          tagBorderRadius: {
            data: {
              max: 40,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 5,
          },
          tagBoxPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 6,
          },
          tagTextSize: {
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 7,
            type: 'RangePx',
          },
          tagTextColor: {
            type: 'HexColor',
            order: 8,
          },
          tagTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 9,
          },
          tagTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 10,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Image_1',
      name: 'Image_1',
      type: 'ProductDetailImage',
      data: {
        text: 'Ürün Başlığı',
        images: [],
      },
      customization: {
        starSize: '16px',
        imageTextSize: '12px',
        imageTextColor: '#212121',
        imageTextStyle: 'normal',
        isShowStar: 'show',
        imageTextWeight: '400',
        showBarcode: 'none',
        tagIconSize: '12px',
        tagTextSize: '10px',
        tagIconColor: '#000000',
        tagTextColor: '#000000',
        tagTextStyle: 'normal',
        showBrandName: 'show',
        tagBoxPadding: '5px 5px 5px 5px',
        tagTextWeight: '400',
        backgroundSize: 'cover',
        barcodeTextSize: '10px',
        tagBorderRadius: '5px 5px 5px 5px',
        barcodeTextColor: '#9C9C9C',
        barcodeTextStyle: 'normal',
        barcodeTextWeight: '400',
        brandNameTextSize: '10px',
        brandNameTextColor: '#000000',
        brandNameTextStyle: 'normal',
        productImageHeight: '274px',
        tagBackgroundColor: '#f5f5f5',
        brandNameTextWeight: '600',
        isShowTag: 'show',
        shareIconColor: '#000000',
        isShareIcon: true,
        shareIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504187_0678e2f1-3319-4a5b-b089-6d9ae7df7031.png',
        shareIconBackgroundColor: '#ffffff',
        shareIconWidth: '20px',
        shareIconBorderRadius: '40px 40px 40px 40px',
        isHeartIcon: true,
        heartIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005139684.png',
        heartIconBackgroundColor: '#ffffff',
        heartIconColor: '#050505',
        selectedHeartIconColor: '#ff0000',
        heartIconWidth: '20px',
        heartIconBorderRadius: '40px 40px 40px 40px',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Image_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default ProductDetailImage;
